import { ETradeMode } from '@webtrader/core/api/market/symbols/detail';
import { EOrderType } from '@webtrader/core/api/order';
import { ETradeFillPolicy } from '@webtrader/core/api/trade';

export const checkIsClosableOrEditable = (params: { marketFillPolicy: ETradeFillPolicy[]; flag?: boolean }) => {
  const { marketFillPolicy, flag } = params;

  return !(!flag || marketFillPolicy?.length === 0);
};

export const getTradeCapabilities = (tradeMode?: ETradeMode) => {
  let isLongAllowed = false;
  let isShortAllowed = false;

  if (tradeMode === ETradeMode.TRADE_FULL || tradeMode === undefined) {
    isLongAllowed = true;
    isShortAllowed = true;
  } else if (tradeMode === ETradeMode.TRADE_LONG) {
    isLongAllowed = true;
  } else if (tradeMode === ETradeMode.TRADE_SHORT) {
    isShortAllowed = true;
  }

  return {
    isLongAllowed,
    isShortAllowed
  };
};

export const isMarketOrder = (orderType: EOrderType | undefined) => {
  if (typeof orderType === 'undefined') {
    return false;
  }
  return [EOrderType.BUY, EOrderType.SELL].includes(orderType);
};

export const isBuyTypeOrder = (orderType: EOrderType | undefined) => {
  if (typeof orderType === 'undefined') {
    return false;
  }
  return [EOrderType.BUY, EOrderType.BUY_LIMIT, EOrderType.BUY_STOP, EOrderType.BUY_STOP_LIMIT].includes(orderType);
};
